import {
	FETCH_WEATHER,
	CLEAR_WEATHER_LIST,
	DELETE_WEATHER_ITEM
} from '../actions/index';

export default (prevState = [], action) => {
	const storedLocations = JSON.parse(localStorage.getItem('localWeather'));
	const prevLocations = storedLocations ? storedLocations : [];
	let weatherState;
	switch (action.type) {
		case FETCH_WEATHER:
			if (action.error) {
				return prevState;
			}
			weatherState = [action.payload.data, ...prevLocations];
			localStorage.setItem('localWeather', JSON.stringify(weatherState));
			return weatherState;
		case CLEAR_WEATHER_LIST:
			localStorage.setItem('localWeather', '[]');
			return [];
		case DELETE_WEATHER_ITEM:
			weatherState = prevLocations.filter(
				item => item.city.name !== action.payload.city.name
			);
			console.log(weatherState);
			localStorage.setItem('localWeather', JSON.stringify(weatherState));
			return weatherState;
		default:
			return prevState;
	}
};



// WEBPACK FOOTER //
// ./src/reducers/Weather.js